import { ThemeColors } from '~/themes/colors'

export interface CallsListViewColors {
  ScrollingList: {
    Item: {
      Title: {
        FontColor_Missed: ThemeColors
      }
      DateTimeFontColor: ThemeColors
      Icon: {
        Default: ThemeColors
        Missed: ThemeColors
      }
    }
  }
}

export const callsListViewColors: CallsListViewColors = {
  ScrollingList: {
    Item: {
      Title: {
        FontColor_Missed: {
          default: 'red.800',
        },
      },
      DateTimeFontColor: {
        default: 'gray.900',
      },
      Icon: {
        Default: {
          default: 'gray.800',
        },
        Missed: {
          default: 'red.800',
        },
      },
    },
  },
}
